import { ModalProps, Modal as AntModal } from "antd";
import React from "react";
import useQueryParams from "../../hooks/useQueryParams";
import styles from './NewMadalR.module.css'

export interface IModalProps extends ModalProps {
  matcher: string | string[];
  removeParamsOnClose?: string[];
  isSaleModal?: boolean;
}

const Modal: React.FC<IModalProps> = ({
  children,
  matcher,
  removeParamsOnClose = [],
  isSaleModal,
  ...props
}) => {
  const query = useQueryParams();
  const matchers = Array.isArray(matcher) ? matcher : [matcher];
  const isVisible = matchers.some((m) => query.has(m));

  return (
    <AntModal
      destroyOnClose
      /*
        Sahifa Drawer i ichidan ochilgan forma oynasi ko'rinmay qolardi
        ("wPurchases?factoryId=null&wPurchases=add" da "Qo'shish" ishlamayotgandek
        tuyulardi). Sabab: antd da Drawer ham, Modal ham z-index 1000 oladi, va
        React portallarni body ga Modal -> Drawer tartibida qo'shadi, ya'ni Drawer
        keyin kelib oynani berkitib qo'yardi. Modal endi 1 pog'ona yuqorida.
        Ochiluvchi ro'yxatlar (1050) va tanlagich Drawer lari (1002) baribir
        yuqorida qoladi.
      */
      zIndex={1001}
      {...props}
      visible={isVisible}
      onCancel={() => query.removeMany(...matchers, ...removeParamsOnClose)}
      className={isSaleModal ? styles.Madal : ''}
    >
      {children}
    </AntModal>
  );
};

export default Modal;
